import type { ComponentNode } from "@shared/types";

import { apiClient } from "./api";

/**
 * Design 模式 API 客户端（frontend → /api/v1/design/*）。
 * 端点：POST /design/image-to-code（图像转代码）、POST /design/figma-import
 * （Figma 链接 + token 服务端代拉）。
 */

export interface ImageToCodeResult {
  /** AppSchema 组件片段（ComponentNode 树），可直接替换页面 layout */
  fragment: ComponentNode;
  /** true = 走了文本占位路径（LLM vision 未配置） */
  degraded: boolean;
  vision: boolean;
  message: string;
  model: string | null;
}

/** 图像转代码：上传设计稿截图（data URL）+ 提示词 → 组件片段。
 *  Atelier 未启用/vision 不可用时后端返回 501（detail.code=vision_unavailable）。 */
export async function imageToCode(
  imageBase64: string,
  prompt: string,
): Promise<ImageToCodeResult> {
  const response = await apiClient.post<ImageToCodeResult>("/design/image-to-code", {
    image_base64: imageBase64,
    prompt,
  });
  return response.data;
}

export interface FigmaImportApiResult {
  /** Figma 文件 key（从链接解析） */
  file_key: string;
  /** 节点 id（链接 node-id 或显式传入），null 表示整文件 */
  node_id: string | null;
  /** Figma file/nodes 原始 JSON，直接喂给 figma-import.ts 的 importFigmaJson */
  data: unknown;
}

/** Figma 导入：粘贴文件链接 + 个人访问 token，服务端代拉 Figma REST API。
 *  token 仅随单次请求转发不落库；链接非法 422，Figma 侧失败 502。 */
export async function fetchFigmaFile(
  fileUrl: string,
  token: string,
): Promise<FigmaImportApiResult> {
  const response = await apiClient.post<FigmaImportApiResult>("/design/figma-import", {
    file_url: fileUrl,
    token,
  });
  return response.data;
}
